import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const DISABLE_IMAGE_REQUEST = 'DISABLE_IMAGE_REQUEST'
export const DISABLE_IMAGE_SUCCESS = 'DISABLE_IMAGE_SUCCESS'
export const DISABLE_IMAGE_FAILURE = 'DISABLE_IMAGE_FAILURE'

export const disableImage = (identity, id) => ({
  [CALL_API]: {
    endpoint: `/api/identities/${identity}/documents/${id}/make-disabled/`,
    types: [DISABLE_IMAGE_REQUEST, DISABLE_IMAGE_SUCCESS, DISABLE_IMAGE_FAILURE],
    method: 'PUT',
    tokenType: API_JWT_TOKEN_NAME,
    body: {},
  },
})
